import React from 'react';

const Arrow = ({ fill, className = '' }) => {
  return (
    <svg width="20" className={className} height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.4546 3L7.45004 9.67273C7.18338 10.0283 7.18338 10.5172 7.45004 10.8727L12.4546 17.5455" stroke={fill} strokeWidth="1.2"/>
    </svg>
  );
};

export default Arrow;
